function isEmptyProperties(obj: Object) {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === '') {
      return true;
    }
  }
  return false;
}

export default isEmptyProperties;
